

import React, { useState } from "react";
import Dietplantop from "../assets/Dietplantopimg.png";
import Dietplanbottom from "../assets/Dietplanbottomimg.png";
import "../css/DietPlanCard.css";
import { LuDownload } from "react-icons/lu";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";

export default function DietPlanCard({
  item,
  isEditable = false,
  onClose,
  onSave,
  onAddService,
  onDelete,
  tag,
  title = "",
  points = [],
  bottomText = "",
  isAdvantagesCard = false,
}) {
  const [editedTitle, setEditedTitle] = useState(title);
  const [editedPoints, setEditedPoints] = useState(points);
  const [editedBottomText, setEditedBottomText] = useState(bottomText);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [editingPointIndex, setEditingPointIndex] = useState(null);
  const [isEditingBottomText, setIsEditingBottomText] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [newPoint, setNewPoint] = useState("");

  const handlePointChange = (value, index) => {
    const updatedPoints = [...editedPoints];
    updatedPoints[index] = value;
    setEditedPoints(updatedPoints);
  };

  const handleKeyDown = (e, fieldType) => {
    if (e.key === "Enter") {
      if (fieldType === "title") setIsEditingTitle(false);
      if (fieldType === "bottomText") setIsEditingBottomText(false);
      if (fieldType === "point") setEditingPointIndex(null);
    }
  };

  const handleNewPointKeyPress = (e) => {
    if (e.key === "Enter" && newPoint.trim() !== "") {
      setEditedPoints([...editedPoints, newPoint.trim()]);
      setNewPoint("");
      setShowInput(false);
    }
  };

  const handlePointDelete = (indexToDelete) => {
    const updatedPoints = editedPoints.filter((_, idx) => idx !== indexToDelete);
    setEditedPoints(updatedPoints);
  };

  const currentPoints = isEditable ? editedPoints : points;

  return (
    <div className={`boarding-card-wrapper ${isEditable ? "editable-modal" : ""}`}>
      <div className="service-diet-plan-card">
        <img
          src={Dietplantop}
          alt="top decoration"
          className="diet-plan-card-top-bg"
        />

        <div className="service-diet-plan-card-body">
          {isEditable ? (
            isEditingTitle ? (
              <input
                type="text"
                value={editedTitle}
                onChange={(e) => setEditedTitle(e.target.value)}
                onBlur={() => setIsEditingTitle(false)}
                onKeyDown={(e) => handleKeyDown(e, "title")}
                className="boarding-edit-input"
                autoFocus
              />
            ) : (
              <h4
                className={
                  isAdvantagesCard
                    ? "service-diet-plan-card-title1"
                    : "service-diet-plan-card-title"
                }
                onClick={() => setIsEditingTitle(true)}
              >
                {editedTitle}
              </h4>
            )
          ) : (
            <h4
              className={
                isAdvantagesCard
                  ? "service-diet-plan-card-title1"
                  : "service-diet-plan-card-title"
              }
            >
              {title}
            </h4>
          )}

          <ul className={`diet-point-list ${isEditable ? "editable-list" : ""}`}>
            {currentPoints.map((point, index) => {
              const [label, ...rest] = point.split(":");
              const content = rest.join(":").trim();

              return (
                <li key={index} className="diet-point-item">
                  {isEditable ? (
                    <div className="diet-point-editable">
                      <span
                        className="hyphen"
                        onClick={() => handlePointDelete(index)}
                        title="Delete this point"
                      >
                        −
                      </span>
                      {editingPointIndex === index ? (
                        <input
                          type="text"
                          value={point}
                          onChange={(e) => handlePointChange(e.target.value, index)}
                          onKeyDown={(e) => handleKeyDown(e, "point")}
                          autoFocus
                        />
                      ) : (
                        <span onClick={() => setEditingPointIndex(index)}>
                          {isAdvantagesCard ? (
                            point
                          ) : (
                            <>
                              <strong>{label.trim()}:</strong> {content}
                            </>
                          )}
                        </span>
                      )}
                    </div>
                  ) : isAdvantagesCard ? (
                    point
                  ) : (
                    <>
                      <strong>{label.trim()}:</strong> {content}
                    </>
                  )}
                </li>
              );
            })}

            {isEditable && showInput && (
              <li className="diet-point-item">
                <span className="hyphen">−</span>
                <input
                  type="text"
                  value={newPoint}
                  onChange={(e) => setNewPoint(e.target.value)}
                  onKeyDown={handleNewPointKeyPress}
                  placeholder="New point"
                  autoFocus
                />
              </li>
            )}
          </ul>

          {isEditable ? (
            isEditingBottomText ? (
              <input
                type="text"
                value={editedBottomText}
                onChange={(e) => setEditedBottomText(e.target.value)}
                onBlur={() => setIsEditingBottomText(false)}
                onKeyDown={(e) => handleKeyDown(e, "bottomText")}
                className="boarding-edit-input"
              />
            ) : (
              <p
                className="diet-card-bottom-text"
                onClick={() => setIsEditingBottomText(true)}
              >
                <strong>Focus: </strong>{editedBottomText || "Click to edit note..."}
              </p>
            )
          ) : (
            <p className="diet-card-bottom-text">
              <strong>Focus:</strong> {bottomText}
            </p>
          )}

          {isEditable && (
            <div className="edit-btns">
              <button className="add-btn" onClick={() => setShowInput(true)}>
                <IoMdAdd className="add-package-icon" color="#EBA8BF" /> Add
              </button>
              <button
                className="save-btn"
                onClick={() => onSave(editedTitle, editedPoints, editedBottomText)}
              >
                <LuDownload className="add-package-icon" color="#EBA8BF" /> Save
              </button>
              <span className="close-btn" onClick={onClose}>
                Close
              </span>
            </div>
          )}

          {!isEditable && (
            <div className="service-diet-plan-card-actions">
              <button
                className="service-diet-plan-edit-button"
                onClick={onAddService}
              >
                <FiEdit size={20} color="#000" /> Edit
              </button>
              <button
                className="service-diet-plan-delete-button"
                onClick={onDelete}
              >
                <RiDeleteBin6Fill size={30} color="#FF3D00" />
              </button>
            </div>
          )}
        </div>

        <div
          className={
            isAdvantagesCard
              ? "service-diet-plan-card-bottom-image1"
              : "service-diet-plan-card-bottom-image"
          }
        >
          <img src={Dietplanbottom} alt="bottom decoration" />
        </div>
      </div>
    </div>
  );
}
